"use client";

import { useParams } from "next/navigation";
import { PYLO_CUSTOMER, SUBDOMAINS } from "@/lib/constants";

export const useCurrentEnterpriseCustomer = () => {
  const { subdomain } = useParams();

  return SUBDOMAINS.find((customer) => customer.name === subdomain) || PYLO_CUSTOMER;
};
